import { render, staticRenderFns } from "./section_list.vue?vue&type=template&id=4c892e82&"
import script from "./section_list.vue?vue&type=script&lang=js&"
export * from "./section_list.vue?vue&type=script&lang=js&"
import style0 from "./section_list.vue?vue&type=style&index=0&id=4c892e82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports